import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React, { useState } from 'react';
import "./styles/heading.css";

function AddRoom (props) {
    const [modal, setModal] = useState(false);
    const [receiver, setReceiver] = useState("");
    const [room_name, setRooom_name] = useState("");
    const handleClose = () => setModal(false);
    const handleShow = () => setModal(true);

    return(
        <div id="add_room" >
            <button  onClick={handleShow} style={{border: "none"}}>
                <img src="./img/add.png" alt="user" />
            </button>

            <Modal show={modal} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title> Create New Chatroom</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <h5 className="border-bottom border-gray pb-2 mb-0">Room name</h5>
                        <input type="text" className="form-control" id="add_room_name" value={room_name} onInput={(e) => {setRooom_name(e.target.value)}} />
                    </div>
                    <h5 className="border-bottom border-gray pb-2 mb-0">With Who</h5>
                    <textarea className="form-control" rows="5" id="add_room" style={{ resize:null , marginLeft: 7}} value={receiver} onInput={(e) => {setReceiver(e.target.value)}} ></textarea>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => {props.handle_add_room(receiver, room_name); setReceiver(""); setModal(false); setRooom_name("");}}>
                    Add
                </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default AddRoom;